import React, { useContext } from 'react'
import { map } from 'lodash'
import { Segment, Divider, Menu, Icon } from 'semantic-ui-react'
import styles from './CurrentOrder.module.scss'

import { ModalSelectCustomer } from '../../../components/ModalSelectCustomer'
// import { ModalSelectVoucher } from '../../../components/ModalSelectVoucher'
import { ICustomer, IVoucher } from '../../../model/customer.model'
// import { TInvoiceSource } from '../../../model/order.store'
import { RootStoreContext } from '../../../model/root-store'
import { ModalChangePartnership } from '../../../components/ModalChangePartnership'
import { CurrentOrderItems } from './CurrentOrderItems'
import { CurrentOrderActions } from './CurrentOrderActions'
import { observer } from 'mobx-react-lite'
import { CurrentOrderCustomer } from './CurrentOrderCustomer'
import { CurrentOrderVoucher } from './CurrentOrderVoucher'
import { CurrentOrderHeader } from './CurrentOrderHeader'
import { ModalChangeShipping } from '../../../components/ModalChangeShipping'
import { partnerDiscounts } from '../../../model/partner-discounts.store'
import { ModalSelectSaleCode } from '../../../components/ModalSelectSaleCode'
import { ModalSelectVoucher } from '../../../components/ModalSelectVoucher'
import { isBefore } from 'date-fns'

// Mapping SKU to product names for better display
// Using the actual SKUs from pre-order-batch.server.lib.js
const mooncakeNameMap: { [key: string]: string } = {
  V10203: 'Bánh dẻo sen nhuyễn trứng muối 4 trứng 400g',
  V10204: 'Bánh nướng cốm xào đặc biệt 160g',
  V10207: 'Combo Bánh nướng + Bánh dẻo'
}

export const CurrentOrder = observer(function CurrentOrder({
  onExpand
}: {
  onExpand: (any: any) => any
}) {
  const rootStore = useContext(RootStoreContext)
  const orderStore = rootStore.orderStore
  const [mooncakeCollapsed, setMooncakeCollapsed] = React.useState(true)

  // Check if there are mooncake pre-orders to display (only for B4 outlet)
  const outletCode = orderStore.getOutletCode()
  const hasMooncakePreOrders =
    isBefore(new Date(), new Date('2025-10-05T00:00:00+07:00')) &&
    outletCode === 'B4' &&
    orderStore.preOrderMooncakeQuantities !== null

  async function onSelectCustomer(customer: ICustomer) {
    orderStore.setCustomer(customer)
  }
  async function onSelectVoucher(voucher: IVoucher) {
    // console.log(voucher)
    orderStore.setVoucher(voucher)
    // console.log(orderStore.voucher, orderStore.availableVouchers)
  }
  async function validateSelectVoucherCode(code: string) {
    if ((orderStore.voucherCode || orderStore.voucherCode !== 'NONE') && !orderStore.voucher) {
      orderStore.setVoucherCode('NONE')
    } else {
      orderStore.setVoucherCode(code)
    }
    // console.log(orderStore.discounts)
    // console.log(orderStore.voucher)
    // console.log(orderStore.voucherCode)
  }
  if (orderStore.onlineOrderId && orderStore.onlineOrder && orderStore.onlineOrder.customer) {
    orderStore.setCustomer(orderStore.onlineOrder.customer)
  }

  const uiStore = rootStore.uiStore

  return (
    <div className={styles['container']}>
      <Menu stackable attached="top" className={styles['menu']}>
        {onExpand && (
          <Menu.Item icon onClick={onExpand}>
            <Icon name={uiStore.createOrderViewLayout === 'order' ? 'arrow right' : 'arrow left'} />
          </Menu.Item>
        )}
        {!orderStore.onlineOrderId && (
          <ModalSelectCustomer onSelectCustomer={onSelectCustomer}>
            <Menu.Item>Thẻ KH</Menu.Item>
          </ModalSelectCustomer>
        )}

        <ModalChangePartnership order={orderStore}>
          <Menu.Item>Đối tác</Menu.Item>
        </ModalChangePartnership>
        <ModalChangeShipping order={orderStore}>
          <Menu.Item>Ship</Menu.Item>
        </ModalChangeShipping>
        <ModalSelectSaleCode order={orderStore}>
          <Menu.Item>Sale Code</Menu.Item>
        </ModalSelectSaleCode>
        <ModalSelectVoucher onSelectVoucher={onSelectVoucher}>
          <Menu.Item>Voucher</Menu.Item>
        </ModalSelectVoucher>
      </Menu>
      <Segment style={{ paddingBottom: '2px' }} attached className={styles['order']}>
        <CurrentOrderCustomer />

        {/* Invoice Request Section - Temporarily hidden while implementing product tax only
        <div
          style={{
            padding: '10px 0',
            borderBottom: '1px solid #e0e0e0',
            marginBottom: '10px'
          }}
        >
          <div style={{ display: 'flex', alignItems: 'center', gap: '15px' }}>
            <label style={{ display: 'flex', alignItems: 'center', cursor: 'pointer' }}>
              <input
                type="checkbox"
                checked={orderStore.requestInvoice}
                onChange={e => orderStore.setRequestInvoice(e.target.checked)}
                style={{ marginRight: '5px' }}
              />
              <span>Xuất hóa đơn</span>
            </label>

            {orderStore.requestInvoice && (
              <select
                value={orderStore.invoiceSource}
                onChange={e => {
                  const value: TInvoiceSource = e.target.value as TInvoiceSource
                  orderStore.setInvoiceSource(value)
                }}
                style={{
                  padding: '5px 10px',
                  border: '1px solid #d9d9d9',
                  borderRadius: '4px',
                  cursor: 'pointer'
                }}
                disabled={!orderStore.canUseHouseholdInvoice}
              >
                <option value="company">Công ty (8%)</option>
                <option value="household" disabled={!orderStore.canUseHouseholdInvoice}>
                  Hộ kinh doanh (1.5%)
                  {!orderStore.canUseHouseholdInvoice && ' - Không thể chọn (có rượu)'}
                </option>
              </select>
            )}

            {orderStore.requestInvoice && orderStore.taxAmount > 0 && (
              <span style={{ marginLeft: 'auto', fontSize: '12px', color: '#666' }}>
                Thuế: {orderStore.taxAmount.toLocaleString('vi-VN')}đ
              </span>
            )}
          </div>

          {orderStore.hasAlcoholItems && orderStore.requestInvoice && (
            <div
              style={{
                marginTop: '8px',
                padding: '5px 10px',
                backgroundColor: '#fff7e6',
                border: '1px solid #ffd591',
                borderRadius: '4px',
                fontSize: '12px',
                color: '#ad6800'
              }}
            >
              <Icon name="info circle" />
              Đơn hàng có sản phẩm chứa rượu, chỉ có thể xuất hóa đơn công ty (8%)
            </div>
          )}
        </div>
        */}

        <CurrentOrderHeader />

        {/* Display Pre-order Mooncake Quantities */}
        {hasMooncakePreOrders && (
          <div
            style={{
              backgroundColor: '#fff7e6',
              border: '1px solid #ffd591',
              borderRadius: '4px',
              padding: '10px',
              marginTop: '10px',
              marginBottom: '10px',
              transition: 'all 0.3s ease'
            }}
          >
            <div
              style={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'space-between',
                marginBottom: mooncakeCollapsed ? '0' : '8px',
                cursor: 'pointer'
              }}
              onClick={() => setMooncakeCollapsed(!mooncakeCollapsed)}
            >
              <div style={{ display: 'flex', alignItems: 'center' }}>
                <Icon name="moon outline" style={{ color: '#fa8c16', marginRight: '8px' }} />
                <strong style={{ color: '#ad6800' }}>Bánh trung thu Pre-Order:</strong>
                {mooncakeCollapsed &&
                  orderStore.preOrderMooncakeQuantities &&
                  (() => {
                    const batchData = orderStore.preOrderMooncakeQuantities as any
                    const activeBatchId = batchData.activeBatchId
                    const quantities = batchData[activeBatchId] || { deo: 0, nuong: 0, combo: 0 }
                    const total = quantities.deo + quantities.nuong
                    return (
                      <span style={{ marginLeft: '10px', color: '#fa8c16', fontWeight: 'bold' }}>
                        {total} bánh
                      </span>
                    )
                  })()}
              </div>
              <Icon
                name={mooncakeCollapsed ? 'chevron down' : 'chevron up'}
                style={{ color: '#ad6800' }}
              />
            </div>
            <div
              style={{
                paddingLeft: '28px',
                maxHeight: mooncakeCollapsed ? '0' : '500px',
                overflow: 'hidden',
                opacity: mooncakeCollapsed ? 0 : 1,
                transition: 'max-height 0.3s ease, opacity 0.3s ease'
              }}
            >
              {map(mooncakeNameMap, (value, key) => {
                return (
                  <div key={key}>
                    {key} {value}
                  </div>
                )
              })}
              <Divider />
              {/* Display current active batch */}
              {orderStore.preOrderMooncakeQuantities &&
                (() => {
                  const batchData = orderStore.preOrderMooncakeQuantities as any
                  const activeBatchName = batchData.activeBatchName
                  const activeBatchId = batchData.activeBatchId
                  const quantities = batchData[activeBatchId] || { deo: 0, nuong: 0, combo: 0 }
                  const total = quantities.deo + quantities.nuong

                  return (
                    <div>
                      <div style={{ fontWeight: 600, color: '#ad6800', marginBottom: '8px' }}>
                        {activeBatchName}:
                      </div>
                      <div style={{ paddingLeft: '16px', fontSize: '13px' }}>
                        <div style={{ marginBottom: '4px' }}>
                          • Bánh dẻo:{' '}
                          <span style={{ color: '#fa8c16', fontWeight: 'bold' }}>
                            {quantities.deo}
                            {batchData.limits && batchData.limits.deo && (
                              <span style={{ fontSize: '12px', fontWeight: 'normal' }}>
                                /{batchData.limits.deo}
                              </span>
                            )}
                          </span>{' '}
                          bánh
                          {batchData.remaining && batchData.remaining.deo !== undefined && (
                            <span style={{ marginLeft: '8px', fontSize: '12px', color: '#8c8c8c' }}>
                              (còn lại: {batchData.remaining.deo})
                            </span>
                          )}
                        </div>
                        <div style={{ marginBottom: '4px' }}>
                          • Bánh nướng:{' '}
                          <span style={{ color: '#fa8c16', fontWeight: 'bold' }}>
                            {quantities.nuong}
                            {batchData.limits && batchData.limits.nuong && (
                              <span style={{ fontSize: '12px', fontWeight: 'normal' }}>
                                /{batchData.limits.nuong}
                              </span>
                            )}
                          </span>{' '}
                          bánh
                          {batchData.remaining && batchData.remaining.nuong !== undefined && (
                            <span style={{ marginLeft: '8px', fontSize: '12px', color: '#8c8c8c' }}>
                              (còn lại: {batchData.remaining.nuong})
                            </span>
                          )}
                        </div>
                        {quantities.combo > 0 && (
                          <div style={{ marginBottom: '4px', fontSize: '12px', color: '#8c8c8c' }}>
                            (Trong đó có {quantities.combo} combo)
                          </div>
                        )}
                        <div
                          style={{
                            marginTop: '8px',
                            paddingTop: '8px',
                            borderTop: '1px solid #ffd591',
                            fontWeight: 500
                          }}
                        >
                          Tổng số lượng đã có đơn:{' '}
                          <span style={{ color: '#fa8c16', fontWeight: 'bold', fontSize: '15px' }}>
                            {total}
                          </span>{' '}
                          bánh
                        </div>
                      </div>
                    </div>
                  )
                })()}
            </div>
          </div>
        )}

        {/* Show selected voucher from search */}
        {(() => {
          const voucher = orderStore.voucher
          if (!voucher) return null

          const isInAvailableVouchers = orderStore.availableVouchers.some(
            availableVoucher => availableVoucher._id === voucher._id
          )
          if (isInAvailableVouchers) {
            return null
          }
          return (
            <div
              style={{
                padding: '10px',
                backgroundColor: '#f0f9ff',
                marginBottom: '10px',
                borderRadius: '4px'
              }}
            >
              <Icon name="ticket" color="blue" />
              <strong>Voucher đã chọn:</strong> {voucher.name}
              {voucher.amount && ` - ${voucher.amount.toLocaleString('vi-VN')}đ`}
              {voucher.quantity
                ? voucher.voucherType.includes('PERCENT')
                  ? ` - ${voucher.quantity}%`
                  : ` - ${voucher.quantity.toLocaleString('vi-VN')}đ`
                : ''}
              {voucher.couponCode && ` - ${voucher.couponCode}`}
              <Icon
                name="close"
                style={{ float: 'right', cursor: 'pointer' }}
                onClick={() => orderStore.setVoucher(null)}
              />
            </div>
          )
        })()}

        {orderStore.orderPlatform !== 'SAVOR_SHOP' ? null : (
          <>
            {!orderStore.computedCustomer && (
              <div
                style={{
                  backgroundColor: '#e6f7ff',
                  border: '1px solid #91d5ff',
                  borderRadius: '4px',
                  padding: '8px 12px',
                  marginTop: '10px',
                  marginBottom: '10px',
                  display: 'flex',
                  alignItems: 'center'
                }}
              >
                <Icon
                  name="info circle"
                  style={{
                    color: '#1890ff',
                    marginRight: '8px',
                    fontSize: '16px'
                  }}
                />
                <div style={{ fontSize: '13px', color: '#0050b3' }}>
                  Bạn nhớ nhập <strong>số điện thoại khách</strong> mua trực tiếp để xem các{' '}
                  <strong>chương trình khuyến mãi</strong> KH thân thiết nhé.
                </div>
              </div>
            )}
            {orderStore.getOutletCode() === 'S6' ? (
              <div
                className={styles['combo-savor-header']}
                style={{
                  color: 'green',
                  border: '1px solid green',
                  padding: '8px',
                  borderRadius: '4px'
                }}
              >
                <strong>Deal hấp dẫn khi mua combo Savor trực tiếp tại cửa hàng:</strong>
                <ol style={{ marginTop: '8px', marginBottom: '0px' }}>
                  <li>
                    Bánh mì Xá xíu + Trà xanh kim quất (M) - giá gốc 45k,{' '}
                    <strong>sale còn 40k</strong>
                  </li>
                  <li>
                    Bánh mì trứng thịt pate + Nước chanh leo (M) - giá gốc 45k,{' '}
                    <strong>sale còn 40k</strong>
                  </li>
                  <li>
                    Xôi gà nấm + Trà xanh kim quất (M) - giá gốc 55k, <strong>sale còn 50k</strong>
                  </li>
                </ol>
              </div>
            ) : (
              <div
                style={{
                  fontSize: '13px',
                  color: '#0050b3',
                  border: '1px solid #0050b3',
                  borderRadius: '4px',
                  padding: '8px',
                  marginTop: '10px',
                  marginBottom: '10px'
                }}
              >
                Với khách mua Set Quà Tết muốn xuất hóa đơn, tạm thời cơ sở tạo Cake Order để CSKH
                xử lý thu đủ tiền gồm thuế phí và tự động tạo được Customer Request xuất hóa đơn
                nhé.
              </div>
            )}
          </>
        )}
        <CurrentOrderVoucher />
        <Divider />

        {orderStore.orderPlatform === 'GRAB_FOOD' && (
          <div>
            <label>Giảm giá đơn hàng GRAB</label>
            <select
              style={{ marginLeft: '1em' }}
              value={orderStore.voucherCode}
              onChange={event => {
                orderStore.setVoucherCode(event.target.value)
                validateSelectVoucherCode(orderStore.voucherCode || 'NONE')
              }}
            >
              <option value="NONE">Không</option>
              {partnerDiscounts
                .filter(discount => discount.orderPlatform === 'GRAB_FOOD')
                .map(discount => (
                  <option key={discount.code} value={discount.code}>
                    {discount.name || discount.code}
                  </option>
                ))}
            </select>
          </div>
        )}
        {orderStore.orderPlatform === 'NOW' && (
          <div>
            <label>Giảm giá đơn hàng NOW</label>
            <select
              style={{ marginLeft: '1em' }}
              value={orderStore.voucherCode}
              onChange={event => {
                orderStore.setVoucherCode(event.target.value)
                validateSelectVoucherCode(orderStore.voucherCode || 'NONE')
              }}
            >
              <option value="NONE">Không</option>
              {partnerDiscounts
                .filter(discount => discount.orderPlatform === 'NOW')
                .map(discount => (
                  <option key={discount.code} value={discount.code}>
                    {discount.name || discount.code}
                  </option>
                ))}
            </select>
          </div>
        )}
        {orderStore.orderPlatform === 'GO_FOOD' && (
          <div>
            <label>Giảm giá đơn hàng GO_FOOD</label>
            <select
              style={{ marginLeft: '1em' }}
              value={orderStore.voucherCode}
              onChange={event => {
                orderStore.setVoucherCode(event.target.value)
                validateSelectVoucherCode(orderStore.voucherCode || 'NONE')
              }}
            >
              <option value="NONE">Không</option>
              {partnerDiscounts
                .filter(discount => discount.orderPlatform === 'GO_FOOD')
                .map(discount => (
                  <option key={discount.code} value={discount.code}>
                    {discount.name || discount.code}
                  </option>
                ))}
            </select>
          </div>
        )}
        {orderStore.orderPlatform === 'BAEMIN' && (
          <div>
            <label>Giảm giá đơn hàng BAEMIN</label>
            <select
              style={{ marginLeft: '1em' }}
              value={orderStore.voucherCode}
              onChange={event => {
                orderStore.setVoucherCode(event.target.value)
                validateSelectVoucherCode(orderStore.voucherCode || 'NONE')
              }}
            >
              <option value="NONE">Không</option>
              {partnerDiscounts
                .filter(discount => discount.orderPlatform === 'BAEMIN')
                .map(discount => (
                  <option key={discount.code} value={discount.code}>
                    {discount.name || discount.code}
                  </option>
                ))}
            </select>
          </div>
        )}
        {orderStore.orderPlatform === 'BE_FOOD' && (
          <div>
            <label>Giảm giá đơn hàng BEFOOD</label>
            <select
              style={{ marginLeft: '1em' }}
              value={orderStore.voucherCode}
              onChange={event => {
                orderStore.setVoucherCode(event.target.value)
                validateSelectVoucherCode(orderStore.voucherCode || 'NONE')
              }}
            >
              <option value="NONE">Không</option>
              {partnerDiscounts
                .filter(discount => discount.orderPlatform === 'BE_FOOD')
                .map(discount => (
                  <option key={discount.code} value={discount.code}>
                    {discount.name || discount.code}
                  </option>
                ))}
            </select>
          </div>
        )}
        {orderStore.orderPlatform === 'NOW' && (
          <div>
            <label>Khuyến mãi</label>
            <select
              style={{ marginLeft: '1em' }}
              value={orderStore.couponCode}
              onChange={event => {
                orderStore.setCouponCode(event.target.value)
              }}
            >
              <option value="NONE">Không</option>
              <option value="FLASH_SALE_25_PERCENT">Flash Sale 25%</option>
            </select>
          </div>
        )}
        {orderStore.orderPlatform === 'GRAB_FOOD' && (
          <div>
            <label>Khuyến mãi</label>
            <select
              style={{ marginLeft: '1em' }}
              value={orderStore.couponCode}
              onChange={event => {
                orderStore.setCouponCode(event.target.value)
              }}
            >
              <option value="NONE">Không</option>
              <option value="CUISINE_GOLDEN_WEEK">Cuisine Week - Tuần Lễ Vàng</option>
              <option value="HOT_PREVENTION">Phòng Nóng Chống Nóng</option>
            </select>
          </div>
        )}

        {orderStore.orderPlatform === 'GO_FOOD' && (
          <div>
            <label>Khuyến mãi</label>
            <select
              style={{ marginLeft: '1em' }}
              value={orderStore.couponCode}
              onChange={event => {
                orderStore.setCouponCode(event.target.value)
              }}
            >
              <option value="">Không áp dụng</option>
              <option value="AN_NGON_GIA_TI_HON_BANH_NGOT">Ăn ngon giá tí hon - BÁNH NGỌT</option>
              <option value="AN_NGON_GIA_TI_HON_XOI_GA_NAM">Ăn ngon giá tí hon - XÔI GÀ NẤM</option>
              <option value="GO_FOOD_MONOPOLY">Món độc quyền</option>
            </select>
          </div>
        )}
        {orderStore.orderPlatform === 'SAVOR_SHOP' && (
          <div>
            <label>Voucher Airpay/Shopeepay</label>
            <select
              style={{ marginLeft: '1em' }}
              value={orderStore.couponCode}
              onChange={event => {
                orderStore.setCouponCode(event.target.value)
              }}
            >
              <option value="">Không áp dụng</option>
              <option value="AIRPAY_CODE">Có sử dụng</option>
            </select>
          </div>
        )}
        {orderStore.orderPlatform === 'SAVOR_SHOP' && (
          <div>
            <label>Khuyến mãi</label>
            <select
              style={{ marginLeft: '1em' }}
              value={orderStore.couponCode}
              onChange={event => {
                orderStore.setCouponCode(event.target.value)
              }}
            >
              <option value="NONE">Không</option>
            </select>
          </div>
        )}
        <CurrentOrderItems />
      </Segment>
      <CurrentOrderActions />
    </div>
  )
})
